import { useSearchParams } from "react-router-dom";
import Content from "@/components/Content";
import { useAuthStore } from "@/store/useAuthStore";
import { resolveDashboardTab } from "@/components/workspace/navigation";
import AnalyticsViewContent from "./components/AnalyticsViewContent";
import StandardsViewContent from "./components/StandardsViewContent";
import UsageControlViewContent from "./components/UsageControlViewContent";
import AdminAnalyticsDashboard from "../admin-analytics/AdminAnalyticsDashboard";
import "./analytics-workspace.css";

const DashboardView = () => {
  const [params] = useSearchParams();
  const user = useAuthStore((s) => s.user);
  const activeTab = resolveDashboardTab(params.get("tab"), user);
  return (
    <Content>
      <div className="et-dashboard">
        {activeTab === "analytics" && <AnalyticsViewContent />}
        {activeTab === "standards" && <StandardsViewContent />}
        {activeTab === "usage-control" && <UsageControlViewContent />}
        {activeTab === "admin" && <AdminAnalyticsDashboard embedded />}
      </div>
    </Content>
  );
};

export default DashboardView;
